import MAisWrapper from './AISWrapper.vue';

export { MAisWrapper };
export default MAisWrapper;
